import React, { Component } from 'react';
import { lang } from 'lang';
import { Button, Text, Scene, AppHeader, View, ConfirmationCodeInput } from 'core';
import { style, theme } from 'constants';
import * as actions from 'actions';

const styles = style({
  content: {
    alignItems: 'center',
    paddingTop: 30
  },
  title: {
    marginBottom: 25,
    color: theme.gray_color,
    textAlign: 'center'
  },
  button: {
    marginTop: 40
  }
});

class NewGroup extends Component {
  state = {
    code: ''
  };
  _join = () => actions.sendGroupJoin(this.state.code);
  render() {
    const { status } = this.props;
    const { code } = this.state;
    return (
      <Scene>
        <AppHeader title={lang.JOIN_GROUP} close />
        <View style={styles.content}>
          <Text style={styles.title}>{lang.ENTER_JOIN_CODE}</Text>
          <ConfirmationCodeInput
            codeLength={4}
            keyboardType="default"
            className="border-circle"
            activeColor={theme.primary_color}
            onChangeText={code => this.setState({ code })}
            inactiveColor={theme.gray_color_lighten(0.2)}
            onFulfill={code => this.setState({ code }, this._join)}
            autoFocus
          />
          <Button
            disabled={code.trim().length !== 4}
            keyboardDismiss
            style={styles.button}
            title={lang.JOIN_GROUP}
            onPress={this._join}
            status={status}
            onSuccess={() => {
              actions.clickCloseModal();
              actions.selectConv();
            }}
          />
        </View>
      </Scene>
    );
  }
}

export default NewGroup;



// WEBPACK FOOTER //
// ./src/components/modals/join_group.js